export default __webpack_public_path__ + "static/media/icPrev.3d881c9e.svg";